import { useState, useEffect } from "react";
import { Col, Container, Row, Card, Spinner, Button, Tooltip, OverlayTrigger, Modal } from "react-bootstrap";
import { toast, Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import { axiosOpen } from "../../api/axios";
import { BsInfoCircle } from 'react-icons/bs';
import "./Profile.scss";

const Profile = () => {
  const [userPlanDetails, setUserPlanDetails] = useState({});
  const userDetails = localStorage.userDetails && JSON.parse(localStorage.userDetails);
  const userID = localStorage.userID && JSON.parse(localStorage.userID);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState({ msg: "", show: false });
  const [isSubscriptionActive, setIsSubscriptionActive] = useState(false);
  const [additionPlanDetails, setAdditionPlanDetails] = useState({});
  const [showCancelSubscriptionModal, setShowCancelSubscriptionModal] = useState(false);

  async function getSubscribedPlan() {
    try {
      const { data } = await axiosOpen.get(`subscriber/get/${userID}`);
      if (data) {
        const date = data.nextDueDate.split('T')[0].split('-').reverse();
        const USDateFormate = `${date[1]}-${date[0]}-${date[2]}`;

        setUserPlanDetails(data?.plan || {});
        setIsSubscriptionActive(data.subscription.subscription_status === 'active' ? true : false);
        setAdditionPlanDetails({
          nextDueDate: USDateFormate,
          remainingListings: data.remainingListings,
        });
      } else {
        setIsSubscriptionActive(false);
      }
      setLoader(false);
    } catch (err) {
      setLoader(false);
      toast.error(err?.response?.data?.message || "Oops! something went wrong.");
    }
  }

  async function processSubscriptionCancellation() {
    const { data } = await axiosOpen.delete(`subscriber/cancel/${userID}`);
    setShowCancelSubscriptionModal(false);
    toast.success('Subscription Cancelled Successfully.');
    getSubscribedPlan()
  }

  useEffect(() => {
    getSubscribedPlan();
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Plan is set to autorenewal. You can cancel the subscription anytime.
    </Tooltip>
  );


  return (
    <div className="profile-page-main-container">
      <Modal show={showCancelSubscriptionModal} onHide={() => setShowCancelSubscriptionModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>We're sorry to see you go!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <span>{`Your monthly subscription is paid until ${additionPlanDetails?.nextDueDate}.`}</span><br/>
            <span>If you would like to proceed with canceling your subscription, please select "Cancel Subscription" below.</span><br/>
            <span className="font-weight-bold">Your subscription plan will be cancelled and there will be no refund.</span><br/>
          </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCancelSubscriptionModal(false)}>
            Undo
          </Button>
          <Button variant="danger" onClick={processSubscriptionCancellation}>
            Cancel Subscription
          </Button>
        </Modal.Footer>
      </Modal>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
      {loader ? (
        <Container className="spinner-container">
          <Spinner animation="border" role="status" style={{ margin: "0 auto" }}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Container>
      ) : (
        <Container className="content-container">
          <Row className="mb-1">
            <Col>
              <h2>Account</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <Card.Header className="font-weight-bold">MEMBERSHIP & BILLING</Card.Header>
                <Card.Body>
                  <Container>
                    <Row className="mb-2">
                      <Col sm={12} md={4} lg={4} xl={4}>
                        <label className="font-weight-bold m-0">Email ID:&nbsp;</label>
                      </Col>
                      <Col sm={12} md={8} lg={8} xl={8}>
                        <span>{userDetails.email}</span>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm={12} md={4} lg={4} xl={4}>
                        <label className="font-weight-bold m-0">First Name:&nbsp;</label>
                      </Col>
                      <Col sm={12} md={8} lg={8} xl={8}>
                        <span>{userDetails.fname}</span>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col sm={12} md={4} lg={4} xl={4}>
                        <label className="font-weight-bold m-0">Last Name:&nbsp;</label>
                      </Col>
                      <Col sm={12} md={8} lg={8} xl={8}>
                        <span>{userDetails.lname}</span>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
            </Col>
          </Row>
            {
              isSubscriptionActive && (<Row className="mt-4">
                <Col>
                  <Card>
                    <Card.Header className="font-weight-bold">PLAN DETAILS</Card.Header>
                    <Card.Body>
                      <Container>
                        {Object.keys(userPlanDetails).length > 0 ? (
                          <>
                            <Row className="mb-2">
                              <Col sm={12} md={4} lg={4} xl={4} className="d-flex align-items-center">
                                <label className="font-weight-bold m-0">Plan Name:&nbsp;</label>
                              </Col>
                              <Col sm={6} md={4} lg={4} xl={4} className="d-flex align-items-center">
                                <span>{userPlanDetails?.name || '---'}</span>
                              </Col>
                              <Col sm={6} md={4} lg={4} xl={4} className="d-flex align-items-center justify-content-end">
                                <Button variant="link" style={{ 'textDecoration': 'none', "padding": 0 }} onClick={() => setShowCancelSubscriptionModal(true)}>Cancel Subscription Plan</Button>
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={12} md={4} lg={4} xl={4}>
                                <label className="font-weight-bold m-0">Next Due Date:&nbsp;</label>
                              </Col>
                              <Col sm={12} md={4} lg={4} xl={4}>
                                <div className="d-flex align-items-center gap-2">
                                  <span>{additionPlanDetails?.nextDueDate || "---"}</span>
                                  <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={renderTooltip}
                                    >
                                      <Button 
                                      style={{
                                        "border":0,
                                        "background": "none",
                                        "color": "#000000",
                                        "padding": 0,
                                        "display": "flex",
                                        "justifyContent": "center", 
                                        "alignItems": "center"
                                        }}>
                                          <BsInfoCircle />
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col sm={12} md={4} lg={4} xl={4}>
                                <label className="font-weight-bold m-0">Remaining Listings:&nbsp;</label>
                              </Col>
                              <Col sm={12} md={4} lg={4} xl={4}>
                                <span>{additionPlanDetails?.remainingListings || "---"}</span>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Row>
                            <Col>
                              <p>
                                You don't have any current active plan&nbsp;
                                <span>
                                  <Link to="/subscription-plans" style={{ textDecoration: "none" }}>
                                    Choose a plan
                                  </Link>
                                </span>
                              </p>
                            </Col>
                          </Row>
                        )}
                      </Container>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>)
            }

        </Container>
      )}
    </div>
  );
};

export default Profile;
